import "~/stubs.ts";
import { loadSettingOverrides } from "~/utils/settings.ts";

loadSettingOverrides().then(() => import("./App.tsx"));
